module.exports = ".card-header-right {\r\n    z-index: 999;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/card/card.component.css
// module id = ./src/app/shared/card/card.component.css
// module chunks = main